import React, { Children, cloneElement, isValidElement } from 'react';
import { useHistory } from 'react-router';

export function LinkBridge({ href, children, onClick, passHref, external }: UIComponents.LinkProps) {
  const history = useHistory();

  const handleClick = async (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    const url = href.toString();
    if (onClick && typeof onClick === 'function') {
      const handled = await onClick(event);
      if (handled || !url) {
        return;
      }
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- auto-generated TECH-258
    if (external) window.location = url as any;
    else history.push(url);
  };

  const childrenWithProps = Children.map(children, (child) => {
    if (!isValidElement(child)) return child;

    const childProps: {
      onClick: React.MouseEventHandler;
      href?: string;
    } = {
      onClick: handleClick,
    };

    if (child.type === 'a' || passHref) {
      childProps.href = href;
    }

    return cloneElement(child, childProps);
  });

  return <>{childrenWithProps}</>;
}

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace -- auto-generated TECH-258
  namespace UIComponents {
    export interface CustomLinkProps {
      // required in search
      external: boolean;
    }
  }
}
